import { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { PROJECTS } from "@/constants/testIds";
import { useLightbox } from "@/components/site/Lightbox";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Projects = () => {
  const [items, setItems] = useState([]);
  const { open } = useLightbox();

  useEffect(() => {
    axios
      .get(`${API}/projects`)
      .then((r) => setItems(r.data))
      .catch(() => setItems([]));
  }, []);

  return (
    <section id="work" data-testid={PROJECTS.root} className="py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20">
        <div className="grid grid-cols-1 md:grid-cols-12 mb-16 items-end gap-6">
          <div className="md:col-span-8">
            <p className="eyebrow mb-6">Selected Work — 2023 / 2024</p>
            <h2 className="font-serif text-5xl md:text-7xl leading-[1.02] tracking-tight">
              Rooms, <span className="italic text-clay">refined.</span>
            </h2>
          </div>
          <p className="md:col-span-4 text-ink/70 max-w-sm md:text-right">
            A small collection of recent commissions. Every piece below was
            built, fit, and finished on site.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10">
          {items.map((p, i) => (
            <motion.article
              key={p.id}
              data-testid={PROJECTS.card(p.id)}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8, delay: i * 0.1 }}
              className={`group ${p.span} col-span-1`}
            >
              <div className="overflow-hidden cursor-zoom-in" onClick={() => open(p.image, p.title)}>
                <img
                  src={p.image}
                  alt={p.title}
                  className={`w-full object-cover transition-transform duration-[1400ms] group-hover:scale-105 ${
                    i % 2 === 0 ? "h-[60vh]" : "h-[50vh]"
                  }`}
                />
              </div>
              <div className="flex justify-between items-end mt-6">
                <div>
                  <p className="eyebrow mb-2">
                    {p.category} — {p.year}
                  </p>
                  <h3 className="font-serif text-3xl md:text-4xl leading-tight">
                    {p.title}
                  </h3>
                </div>
                <span className="font-serif italic text-ink/40 text-2xl hidden sm:inline">
                  0{i + 1}
                </span>
              </div>
              <p className="mt-4 text-ink/70 max-w-lg leading-relaxed">
                {p.description}
              </p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};
